import { render, staticRenderFns } from "./searchProduct.vue?vue&type=template&id=239fddac&scoped=true"
import script from "./searchProduct.vue?vue&type=script&lang=js"
export * from "./searchProduct.vue?vue&type=script&lang=js"
import style0 from "./searchProduct.vue?vue&type=style&index=0&id=239fddac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239fddac",
  null
  
)

export default component.exports